import { CircularProgress } from '@civilgrid/ui/components';
import { useMemo } from 'react';
import type { UseFormReturn } from 'react-hook-form';
import { useAsyncRetry } from 'react-use';
import { getCivilSearchers } from '~/api/civilsearch';
import type { DataRequestV2 } from '~/common/types';
import ControlledSelect from '~/components2/forms/controlled/ControlledSelect';
import type { Item } from '~/components2/forms/Select';
import type { TFormValues } from './GeneralForm';

interface AdminProps {
  form: UseFormReturn<TFormValues, any>;
  dataRequest: DataRequestV2;
}

export default function AdminSelect({ form, dataRequest }: AdminProps) {
  const civilSearchers = useAsyncRetry(() => getCivilSearchers(), [dataRequest.id]);

  const civilSearcherItems = useMemo<Item[]>(() => {
    if (!civilSearchers.value) return [];

    return civilSearchers.value.map((searcher) => ({
      value: searcher.userId,
      label: (
        <div>
          <div className="text-sm">{searcher.name}</div>
          <div className="text-xs truncate">{searcher.email}</div>
        </div>
      ),
      keywords: [searcher.email, searcher.name],
    }));
  }, [civilSearchers]);

  if (civilSearchers.loading) return <CircularProgress indeterminate />;

  if (civilSearchers.error || !civilSearchers.value) {
    return <div>An error occurred fetching civil searchers</div>;
  }

  return (
    <ControlledSelect
      control={form.control}
      name="assignedTo"
      label="Assigned To"
      items={civilSearcherItems}
      isRequired={false}
      tooltipText="The civil searcher this request is assigned to"
      popoverTriggerClassName="w-full"
      multiLineTrigger
    />
  );
}
